// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-o_hw","advertDetailServiceList__header":"c-o_hx","advertDetailServiceList__list":"c-o_hy"};